import { MovinmotionApplication } from '@movinmotion/conf-shared';
import { App } from '@movinmotion/design-system';
import { AuthLayoutApp } from '@movinmotion/shared/ui/layout';

export enum AppDisplay {
  core = 'core',
  adminBo = 'adminBo',
  accounting = 'accounting',
  social = 'social',
  worker = 'worker',
  talents = 'talents',
  filmFranceTalents = 'fft',
  odalie = 'odalie',
  employeur = 'employeur',
}

export const movinMotionApp: { [key in AppDisplay]: string } = {
  [AppDisplay.core]: 'CORE',
  [AppDisplay.accounting]: 'COMPTA',
  [AppDisplay.social]: 'SOCIAL',
  [AppDisplay.employeur]: 'SOCIAL',
  [AppDisplay.worker]: 'WORKER',
  [AppDisplay.talents]: 'TALENTS',
  [AppDisplay.filmFranceTalents]: 'TALENTS',
  [AppDisplay.odalie]: 'CORE',
  [AppDisplay.adminBo]: 'ADMIN_BO',
};

export const titlePrefix: { [key in AppDisplay]: string } = {
  [AppDisplay.core]: 'Movinmotion',
  [AppDisplay.accounting]: 'Movinmotion Compta',
  [AppDisplay.social]: 'Movinmotion Social',
  [AppDisplay.employeur]: 'Movinmotion',
  [AppDisplay.worker]: 'Movinmotion Salarié',
  [AppDisplay.talents]: 'Movinmotion Talents',
  [AppDisplay.filmFranceTalents]: 'Film France Talents',
  [AppDisplay.odalie]: 'Thalie Santé',
  [AppDisplay.adminBo]: 'Movinmotion',
};

export const appLogoByDisplay: { [key in AppDisplay]: App } = {
  [AppDisplay.core]: 'EMPLOYEUR',
  [AppDisplay.accounting]: 'EMPLOYEUR',
  [AppDisplay.social]: 'EMPLOYEUR',
  [AppDisplay.employeur]: 'EMPLOYEUR',
  [AppDisplay.worker]: 'WORKER',
  [AppDisplay.talents]: 'EMPLOYEUR',
  [AppDisplay.filmFranceTalents]: 'FILMFRANCE',
  [AppDisplay.odalie]: 'ODALIE',
  [AppDisplay.adminBo]: 'ADMIN',
};

export const favicon: { [key in AppDisplay]: string } = {
  [AppDisplay.core]: '/assets/img/favicons/favicon-core.png',
  [AppDisplay.accounting]: '/assets/img/favicons/favicon-accounting.png',
  [AppDisplay.social]: '/assets/img/favicons/favicon-social.png',
  [AppDisplay.employeur]: '/assets/img/favicons/favicon-social.png',
  [AppDisplay.worker]: '/assets/img/favicons/favicon-worker.png',
  [AppDisplay.talents]: '/assets/img/favicons/favicon-talents.png',
  [AppDisplay.filmFranceTalents]: '/assets/img/favicons/favicon-fft.png',
  [AppDisplay.odalie]: '/assets/img/favicons/favicon-social.png',
  [AppDisplay.adminBo]: '/assets/img/favicons/favicon-social.png',
};

export const appDisplayToAuthApp: Record<AppDisplay, AuthLayoutApp> = {
  [AppDisplay.core]: 'EMPLOYEUR',
  [AppDisplay.accounting]: 'EMPLOYEUR',
  [AppDisplay.social]: 'EMPLOYEUR',
  [AppDisplay.employeur]: 'EMPLOYEUR',
  [AppDisplay.worker]: 'SALARIE',
  [AppDisplay.talents]: 'EMPLOYEUR',
  [AppDisplay.filmFranceTalents]: 'FILMFRANCE',
  [AppDisplay.odalie]: 'ODALIE',
  [AppDisplay.adminBo]: 'ADMIN_BO',
};

export const mappingMovinmotionApplicationToAppDisplay: { [key in MovinmotionApplication]: AppDisplay } = {
  [MovinmotionApplication.core]: AppDisplay.employeur,
  [MovinmotionApplication.accounting]: AppDisplay.employeur,
  [MovinmotionApplication.social]: AppDisplay.employeur,
  [MovinmotionApplication.nda]: AppDisplay.employeur,
  [MovinmotionApplication.worker]: AppDisplay.worker,
  [MovinmotionApplication.talents]: AppDisplay.talents,
  [MovinmotionApplication.odalie]: AppDisplay.odalie,
  [MovinmotionApplication.adminBo]: AppDisplay.adminBo,
};
